import React from 'react';
import { Grid } from '@mui/material';
import { Bookings } from '../../config';
import { ActionButton } from '..';

export const MeetingSetup: React.FC = React.memo(() => {
    return (
        <>
            <Grid item xs={12}>
                <h3 style={{ fontWeight: 500, color: '#555' }}>
                    Making a booking with:
                </h3>
            </Grid>
            <ActionButton
                title='Prispek'
                type='button'
                sx={{ pt: '1.5rem', pb: '1.5rem' }}
                sm={4}
                color='secondary'
                variant='contained'
                disableElevation
                disableFocusRipple
                disableTouchRipple
                grid
            />
            <ActionButton
                title='Spektra'
                type='button'
                sx={{ pt: '1.5rem', pb: '1.5rem' }}
                color='inherit'
                variant='outlined'
                sm={4}
                href={Bookings.Spektra}
                disableElevation
                disableFocusRipple
                disableTouchRipple
                grid
            />
            <ActionButton
                title='Prisma'
                type='button'
                sx={{ pt: '1.5rem', pb: '1.5rem' }}
                color='inherit'
                sm={4}
                variant='outlined'
                href={Bookings.Prisma}
                disableElevation
                disableFocusRipple
                disableTouchRipple
                grid
            />
        </>
    );
});
